module.exports = __webpack_public_path__ + "static/media/flag_shape_dark.7dc66380.svg";